<template>
  <div class="container client">
    <div class="header card">
      <el-breadcrumb class="breadcrumb"
                     separator="/">
        <el-breadcrumb-item>学长</el-breadcrumb-item>
        <el-breadcrumb-item>任务大厅</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">任务大厅</h2>
        </div>
        <div class="right">
          <el-button class="button"
                     type="primary"
                     @click="createDialog = true">创建</el-button>
        </div>
      </div>
    </div>
    <el-card style="margin-top: 20px">
      <el-form class="search-wrap"
               ref="searchForm"
               :inline="true"
               :model="query"
               size="small"
               label-position="left">
        <el-form-item label="任务要求关键字">
          <el-input v-model.trim="query.demand_keyword"
                    placeholder="请输入任务要求关键字"
                    @input="getList(true)"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="任务状态">
          <el-select v-model="query.statuses"
                     placeholder="请选择"
                     @change="getList(true)"
                     clearable
                     multiple
                     collapse-tags>
            <el-option v-for="(item,index) in filters.statuses"
                       :key="index"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="任务类型">
          <el-select v-model="query.types"
                     placeholder="请选择"
                     @change="getList(true)"
                     clearable
                     multiple
                     collapse-tags>
            <el-option v-for="(item,index) in filters.types"
                       :key="index"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="联系人关键字">
          <el-input v-model.trim="query.contact_user_keyword"
                    placeholder="请输入联系人关键字"
                    @input="getList(true)"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="对接人">
          <el-select v-model="query.creators"
                     placeholder="请选择"
                     @change="getList(true)"
                     clearable
                     multiple
                     collapse-tags>
            <el-option v-for="item in $store.state.staffOptions"
                       :key="item.id"
                       :label="item.nickname"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="发布日期">
          <el-date-picker class="datetime"
                          v-model="create_time"
                          type="datetimerange"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          @change="getList(true)"
                          clearable>
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间">
          <el-date-picker class="datetime"
                          v-model="end_time"
                          type="datetimerange"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          @change="getList(true)"
                          clearable>
          </el-date-picker>
        </el-form-item>
      </el-form>

    </el-card>
    <el-card style="margin-top: 20px">
      <div class="card-header">
        <h3 class="title">任务列表</h3>
      </div>
      <el-table :data="results"
                :header-cell-style="{
          textAlign: 'center',
        }"
                @selection-change="handleSelectionChange"
                border>
        <el-table-column type="selection"
                         width="50"
                         fixed="left"
                         align="center"></el-table-column>
        <el-table-column fixed="left"
                         label="编号"
                         width="120"
                         align="center"
                         prop="order_no">
        </el-table-column>
        <el-table-column align="center"
                         label="任务状态"
                         width="100">
          <template slot-scope="scope">
            <div class="tag-wrap">
              <el-tag v-if="scope.row.status==0"
                      size="mini">等待审核</el-tag>
              <el-tag v-if="scope.row.status==1"
                      size="mini"
                      type="warning">正在进行</el-tag>

              <el-badge is-dot
                        class="item"
                        v-if="scope.row.status==2">
                <el-tag size="mini"
                        type="danger"
                        @click="openreason(scope.row)">审核驳回</el-tag>
              </el-badge>
              <el-tag v-if="scope.row.status==3"
                      size="mini"
                      type="info">任务结束</el-tag>
              <el-tag v-if="scope.row.status==4"
                      size="mini"
                      type="info">任务取消</el-tag>
            </div>

          </template>
        </el-table-column>
        <el-table-column align="center"
                         label="发布日期"
                         width="150">
          <template slot-scope="scope">
            {{scope.row.create_time?$moment(scope.row.create_time).format("YYYY-MM-DD HH:mm"):""}}
          </template>
        </el-table-column>
        <el-table-column label="任务类型"
                         align="center"
                         width="100">
          <template slot-scope="scope">
            {{formateType(scope.row.type)}}
          </template>
        </el-table-column>
        <el-table-column label="任务要求"
                         align="center"
                         min-width="300"
                         show-overflow-tooltip
                         prop="demand">
          <template slot-scope="scope">
            <div class="left">
              {{scope.row.demand}}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="要求人数"
                         width="80"
                         align="center"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            {{scope.row.work_user_count}}人
          </template>
        </el-table-column>
        <el-table-column label="截止日期"
                         align="center"
                         width="150">
          <template slot-scope="scope">
            {{scope.row.end_time?$moment(scope.row.end_time).format("YYYY-MM-DD HH:mm"):""}}
          </template>
        </el-table-column>
        <el-table-column label="佣金"
                         width="80"
                         align="center"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <span style="color:#f56c6c;">
              {{scope.row.referrer_amount}}元
            </span>
          </template>
        </el-table-column>
        <el-table-column label="任务联系人"
                         align="center"
                         width="230"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            {{scope.row.contact_user_name}} / {{scope.row.contact_user_wechat}}
          </template>
        </el-table-column>
        <el-table-column label="创建人"
                         align="center"
                         width="80"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            {{scope.row.admin_creator?scope.row.admin_creator.nickname:'暂无'}}
          </template>
        </el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="230"
                         align="center">
          <template slot-scope="scope">
            <div class="link-wrap">
              <el-link type="primary"
                       :underline="false"
                       @click="handleToEdit(scope.row)"
                       :disabled="scope.row.status!=0">编辑</el-link>
              <div class="badge-content">
                <el-link type="primary"
                         :underline="false"
                         @click="handleToDetail(scope.row.id)">查看详情</el-link>
                <div class="badge"
                     v-if="scope.row.count_commit_log_tocheck">{{scope.row.count_commit_log_tocheck?scope.row.count_commit_log_tocheck:0}}</div>
              </div>
              <el-link type="danger"
                       :underline="false"
                       :disabled="scope.row.status!=1"
                       @click="handleToChangeStatus(scope.row.id)">任务终止</el-link>
            </div>

          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 16px"
           class="footer">
        <div>
          <el-button size="mini"
                     type="danger"
                     @click="handleToDeleteAll()">批量删除</el-button>
        </div>

        <div class="block">
          <el-pagination background
                         layout="total, prev, pager, next, sizes, jumper"
                         :current-page="Number(query.pageIndex)"
                         :page-sizes="[10, 20, 50, 100, 500]"
                         :page-size="Number(query.pageSize)"
                         :total="Number(pageTotal)"
                         @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"></el-pagination>
        </div>
      </div>
    </el-card>
    <AddTask :isVisible="createDialog"
             @close="createDialog=false"
             @submit="getList()"></AddTask>
    <EditTask :isVisible="editDialog"
              :id="editId"
              @close="editDialog=false"
              @submit="getList()"></EditTask>
    <RefuseDialog :isVisible="refuseVisible"
                  @close="refuseVisible=false"
                  @submit="RefuseDialogSubmit"></RefuseDialog>
    <el-dialog title="拒绝理由"
               :visible.sync="reasonDialog"
               width="700px"
               :close-on-click-modal="false"
               @close="reasonDialog=false">
      {{reason}}
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="reasonDialog=false">取 消</el-button>
        <el-button type="primary"
                   @click="reasonDialog=false">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import AddTask from '@/components/dialog/senior/AddTask.vue'
import EditTask from '@/components/dialog/senior/EditTask.vue'
import RefuseDialog from '@/components/dialog/RefuseDialog.vue'

import { manageUrl } from '@/utils/helper.js'

export default {
  components: {
    AddTask,
    EditTask,
    RefuseDialog,
  },
  data() {
    return {
      TableName: '任务列表',
      results: [],
      createDialog: false,
      query: {
        pageIndex: 1,
        pageSize: 10,
        isPaging: 1,
      },
      pageTotal: 0,
      chooseList: [],
      editDialog: false,
      editId: null,
      refuseVisible: false,
      create_time: '',
      end_time: '',
      reason: '',
      reasonDialog: false,
      filters: {
        statuses: [
          { label: '等待审核', value: 0 },
          { label: '正在进行', value: 1 },
          { label: '审核驳回', value: 2 },
          { label: '任务结束', value: 3 },
          { label: '任务取消', value: 4 },
        ],
        types: [
          { label: '辅导推荐', value: 1 },
          { label: '资料制作', value: 2 },
          { label: '讲座答疑', value: 3 },
          { label: '课程分销', value: 4 },
          { label: '其他综合', value: 5 },
        ],
      },
    }
  },
  created() {
    this.parseQuery()
    this.getList()
  },
  watch: {
    // 时间数据监听
    create_time(value) {
      if (value) {
        this.query.start_create_time = this.$moment(value[0]).valueOf()
        this.query.end_create_time = this.$moment(value[1]).valueOf()
      } else {
        this.query.start_create_time = ''
        this.query.end_create_time = ''
        this.getList(true)
      }
    },
    // 时间数据监听
    end_time(value) {
      if (value) {
        this.query.start_end_time = this.$moment(value[0]).valueOf()
        this.query.end_end_time = this.$moment(value[1]).valueOf()
      } else {
        this.query.start_end_time = ''
        this.query.end_end_time = ''
        this.getList(true)
      }
    },
  },
  computed: {},
  methods: {
    handleSizeChange(val) {
      this.query.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.query.pageIndex = val
      this.getList()
    },
    getList(isReset = false) {
      if (isReset) {
        this.$set(this.query, 'pageIndex', 1)
      }
      const params = Object.assign({}, this.query)
      if (params.statuses) {
        params.statuses = params.statuses.join(',')
      }
      if (params.types) {
        params.types = params.types.join(',')
      }
      if (params.creators) {
        params.creators = params.creators.join(',')
      }
      if (isReset) {
        this.query.pageIndex = 1
      }
      let str = manageUrl()
      // @@@@@@@@
      this.$axios({
        url: `${str}/api/v1/seniorWork/taskRoom/task/list`,
        method: 'get', //可以省略 不写默认是get
        params: params,
        headers: {
          // 设置请求头
          Authorization: localStorage.getItem('admin_token'),
        },
      }).then((response) => {
        let res = response.data
        if (res.code == 0) {
          this.results = res.data.list
          this.pageTotal = res.data.count
        }
      })
      this.syncQuery()
    },
    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach((key) => {
        this.query[key] = this.$route.query[key]
      })
      if (this.query.statuses && this.query.statuses.length) {
        this.query.statuses = this.query.statuses.split(',').map((v) => {
          return Number(v)
        })
      }
      if (this.query.types && this.query.types.length) {
        this.query.types = this.query.types.split(',').map((v) => {
          return Number(v)
        })
      }
      if (this.query.creators && this.query.creators.length) {
        this.query.creators = this.query.creators.split(',').map((v) => {
          return Number(v)
        })
      }
    },
    // 同步URL请求参数
    syncQuery() {
      const params = Object.assign({}, this.query)
      let isSync = Object.keys(params).some(
        (key) => this.$route.query[key] != params[key]
      )
      if (params.statuses) {
        params.statuses = params.statuses.filter((v) => v).join(',')
      }
      if (params.statuses) {
        params.statuses = params.statuses.filter((v) => v).join(',')
      }
      if (params.creators) {
        params.creators = params.creators.filter((v) => v).join(',')
      }
      isSync &&
        this.$router.replace({
          query: Object.assign({}, this.$route.query, params),
        })
    },
    handleSelectionChange(val) {
      this.chooseList = val
    },
    formateType(val) {
      let types = {
        1: '辅导推荐',
        2: '资料制作',
        3: '讲座答疑',
        4: '课程分销',
        5: '其他综合',
      }
      return types[val]
    },
    handleToEdit(row) {
      this.editId = row.id
      this.editDialog = true
    },
    handleToDeleteAll() {
      if (this.chooseList.length == 0) {
        this.$message.error('还没有选择要删除的数据')
        return
      }
      this.$confirm('确定要删除这些信息吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let ids = this.chooseList.map((v) => {
          return v.id
        })

        let str = manageUrl()
        // @@@@@@
        this.$axios({
          url: `${str}/api/v1/seniorWork/taskRoom/task/list`,
          method: 'delete', //可以省略 不写默认是get
          data: {
            ids,
          },
          headers: {
            // 设置请求头
            Authorization: localStorage.getItem('admin_token'),
          },
        }).then((response) => {
          let res = response.data
          if (res.code == 0) {
            this.getList()
          }
        })
      })
    },
    handleToAccept(is_accept, id) {
      this.$confirm('确定要通过吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        taskcheck({
          id: id,
          is_access: is_accept,
        }).then((res) => {
          this.getList()
        })
      })
    },
    RefuseDialogSubmit({ text }) {
      taskcheck({
        id: this.editId,
        is_access: 0,
        refuse_reason: text,
      }).then((res) => {
        this.getList()
      })
    },
    openRefuseDialog(id) {
      this.refuseVisible = true
      this.editId = id
    },
    openreason(row) {
      this.reason = row.refuse_reason
      this.reasonDialog = true
    },
    handleToDetail(id) {
      this.$router.push(`/senior/task/${id}`)
    },
    handleToChangeStatus(id) {
      this.$confirm('确定要取消任务吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let str = manageUrl()
        // @@@@@@@
        this.$axios({
          url: `${str}/api/v1/seniorWork/taskRoom/task`,
          method: 'put', //可以省略 不写默认是get
          data: {
            id: id,
            status: 4,
          },
          headers: {
            // 设置请求头
            Authorization: localStorage.getItem('admin_token'),
          },
        }).then((response) => {
          let res = response.data
          if (res.code == 0) {
            this.getList()
          }
        })
      })
    },
  },
}
</script>

<style lang="less" scoped>
.client {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }

  .table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
      overflow-y: visible;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
    }
    .footer {
      display: flex;
      justify-content: space-between;
      margin-top: 20px;
    }
  }
}
.el-link {
  font-size: 12px;
  margin: 0px 5px;
}
.el-tag {
  margin: 0px 5px;
}
.tag-wrap {
  text-align: left;
}
.card-header {
  margin-bottom: 16px;
}
.footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.link-wrap {
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.left {
  width: 100%;
  text-align: left;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.badge-content {
  position: relative;
  .badge {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background-color: #f56c6c;
    color: #fff;
    font-size: 11px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: -5px;
    top: -2px;
  }
}
</style>
